export default "__VITE_ASSET__Dn77882R__"